import { render, staticRenderFns } from "./Fase5.vue?vue&type=template&id=d81a3290&scoped=true"
import script from "./Fase5.vue?vue&type=script&lang=js"
export * from "./Fase5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d81a3290",
  null
  
)

export default component.exports